import { setStringAsync } from "expo-clipboard";
import { useCallback, useMemo, useState } from "react";
import { View } from "react-native";
import AddonVariant from "src/api/graphql/__generated__/enums/AddonVariant";
import linkSrc from "src/assets/images/addons/link.png";
import locationSrc from "src/assets/images/addons/location.png";
import spotifySrc from "src/assets/images/addons/spotify.png";
import venmoSrc from "src/assets/images/addons/venmo.png";
import RoundedButton from "src/components/RoundedButton";
import Touchable from "src/components/Touchable";
import IconClose from "src/icons/IconClose";
import { useInsideModal } from "src/modals";
import GlobalModal from "src/modals/configs/GlobalModal";
import { paddingLarge, paddingMedium, paddingXXXL } from "src/styles/spacing";
import { Image, Text } from "src/swsh-native";
import { useAddonCopyModalDimensions } from "./AddonCopyModalSkeleton";
import { ADDON_COPY_MODAL_LABELS } from "./constants";

const AddonCopyModal = () => {
	const style = useAddonCopyModalDimensions();
	const {
		closeSelf,
		props: { text, variant },
	} = useInsideModal<GlobalModal["AddonCopyModal"]>();
	const imageSrc = useMemo(() => {
		switch (variant) {
			case AddonVariant.Venmo:
				return venmoSrc;
			case AddonVariant.Location:
				return locationSrc;
			case AddonVariant.Spotify:
				return spotifySrc;
			case AddonVariant.Link:
			default:
				return linkSrc;
		}
	}, [variant]);
	const [copied, setCopied] = useState(false);

	const handleCopy = useCallback(async () => {
		const copied = await setStringAsync(text);
		setCopied(copied);
	}, [text]);

	return (
		<View
			style={[
				style,
				{
					flexDirection: "column",
					rowGap: paddingXXXL,
					padding: paddingLarge,
				},
			]}
		>
			<View>
				<Touchable
					testID="AddonCopyModalCloseButton"
					onPress={closeSelf}
					containerStyle={{
						alignSelf: "flex-end",
					}}
				>
					<IconClose size={20} />
				</Touchable>

				<View style={{ alignItems: "center", paddingTop: paddingMedium }}>
					<Text testID="AddonCopyModalTitle" semiLarge bold>
						{ADDON_COPY_MODAL_LABELS[variant]}
					</Text>
				</View>
			</View>

			<View style={{ alignItems: "center" }}>
				<Image
					alt="Supplementary graphic for addon"
					src={imageSrc}
					dim={{ width: 208, aspectRatio: 1 }}
				/>
			</View>

			<Text testID="AddonCopyModalText" basic bold style={{ textAlign: "center" }}>
				{text}
			</Text>

			<RoundedButton
				testID="AddonCopyModalCopyButton"
				onPress={handleCopy}
				sizeVariant="Medium"
				colorVariant={copied ? "Contrast" : "Hollow"}
				containerStyle={{ alignItems: "center" }}
			>
				{copied ? "Copied!" : "Copy"}
			</RoundedButton>
		</View>
	);
};
export default AddonCopyModal;
